import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
}
export function App() {
  useEffect(() => {
    initMetaPixel();
    window.fbq('init', '1404742387373119');
    window.fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}